import breakpoints from './breakpoints.configs';

const theme = {
  breakpoints,
  fontFamily: 'montserrat, sans-serif',
};

export default theme;
